import * as Yup from 'yup';

const Validation = Yup.object({
    name: Yup.string().required("Please enter name!"),
    imageUrl: Yup.string().required("Please upload logo!"),
});

export default Validation;
